import React from 'react';
import ReactDOM from "react-dom/client";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {applyMiddleware, createStore} from "redux";
import {Provider} from "react-redux";
import thunk from "redux-thunk";
import {IntlProvider} from 'react-intl';
import {composeWithDevTools} from "redux-devtools-extension";
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import i18Config from "./i18Config";

import rootReducer from "./rootReducer";
import setSurveyLangHeader from "./utils/setSurveyLangHeader";
import setAuthorizationHeader from "./utils/setAuthorizationHeader";
import axios from "axios";
import storeInit from "./storeInit";


import 'url-polyfill';

import 'bootstrap/scss/bootstrap.scss';
import 'ladda/css/ladda.scss';
import 's/styles/style.scss';

const consoleWarn = console.warn;
const consoleError = console.error;
const SUPPRESSED_WARNINGS = ['Warning:'];

if (process.env.ENV === 'production') {
  console.warn = function filterWarnings(msg, ...args) {
    if (!SUPPRESSED_WARNINGS.some((entry) => msg.includes(entry))) {
      consoleWarn(msg, ...args);
    }
  };

  console.error = function filterWarnings(msg, ...args) {
    if (!SUPPRESSED_WARNINGS.some((entry) => msg.includes(entry))) {
      consoleError(msg, ...args);
    }
  };
}

const link = new URL(window.location.href);

if (link.searchParams.get('id')) {
  axios.defaults.headers.common.response = link.searchParams.get('id');
}
if (link.searchParams.get('screenout')) {
  axios.defaults.headers.common.screenout = 1;
}
if (link.searchParams.get('quota')) {
  axios.defaults.headers.common.quota = 1;
}

const store = storeInit;

if(localStorage.surveyLanguage) {
  setSurveyLangHeader(localStorage.surveyLanguage);
}

if(localStorage.jwt) {
  setAuthorizationHeader(localStorage.jwt);
}

let url = new URL(window.location.href);
if(url.searchParams.get("auth")){
  setAuthorizationHeader(url.searchParams.get("auth"));
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <IntlProvider locale={i18Config.locale} messages={i18Config.messages}>
    <BrowserRouter>
      <Provider store={store}>
        <Routes>
          <Route path="*" element={<App />} />
        </Routes>
      </Provider>
    </BrowserRouter>
  </IntlProvider>);
registerServiceWorker();
